/* FASE 4 — Etiquetas únicas para `order.review_reason`.
 * ADMIN_LABEL: texto técnico para el panel administrativo.
 * CLIENT_MESSAGE: texto tranquilizador para el cliente (solo los motivos
 * que el cliente puede llegar a ver en el modal de resultado). */

export const REVIEW_REASON_LABEL = {
  AMOUNT_MISMATCH: "Monto leído ≠ Monto declarado",
  LOW_CONFIDENCE_MONTO: "Confianza baja en el Monto (<85%)",
  LOW_CONFIDENCE_REFERENCIA: "Confianza baja en la Referencia (<85%)",
  MISSING_MONTO: "Falta el Monto en el comprobante",
  MISSING_REFERENCIA: "Falta la Referencia en el comprobante",
  MISSING_FIELDS: "Faltan campos en el comprobante",
  BNC_TOTAL_DETECTED: "BNC: solo se detectó 'Total:' (incluye comisión)",
  IMAGE_LOW_QUALITY: "Imagen de baja calidad",
  FORENSIC_WEAK_SIGNAL: "Señal forense débil",
  FORENSIC_TAMPERING: "Posible manipulación",
  FIELD_MISMATCH: "Datos no coinciden con la configuración",
  DUPLICATE_REFERENCE: "Referencia duplicada",
  INVALID_RECEIPT: "No parece comprobante válido",
  SOFT_MISMATCH: "Discrepancia leve",
  USD_PLATFORM_MANUAL: "Pago en USD (revisión manual)",
  MANUAL_REJECT: "Rechazado manualmente",
  UNREGISTERED_BANK: "Banco no registrado — requiere revisión manual",
  BANK_NOT_REGISTERED: "Banco no registrado — requiere revisión manual",
};

const UNREGISTERED_BANK_CLIENT_MSG =
  "Tu comprobante fue recibido correctamente. El banco emisor no está en nuestra lista, " +
  "así que un agente lo revisará manualmente en unos minutos. Tu pedido ya quedó registrado.";

export const REVIEW_REASON_CLIENT_MESSAGE = {
  UNREGISTERED_BANK: UNREGISTERED_BANK_CLIENT_MSG,
  BANK_NOT_REGISTERED: UNREGISTERED_BANK_CLIENT_MSG,
  MISSING_REFERENCIA:
    "Recibimos tu comprobante, pero no pudimos leer la referencia con seguridad. " +
    "Un agente la verificará manualmente en unos minutos. Tu pedido ya quedó registrado.",
  IMAGE_LOW_QUALITY:
    "Hemos recibido tu comprobante. Debido a la calidad de la imagen, un agente lo revisará " +
    "manualmente en unos minutos. ¡No te preocupes, tu pedido está registrado!",
};

export const DEFAULT_REVIEW_CLIENT_MESSAGE =
  "Hemos recibido tu comprobante y un agente lo revisará manualmente en unos minutos. " +
  "¡No te preocupes, tu pedido está registrado!";

export function reviewReasonLabel(reason) {
  if (!reason) return null;
  return REVIEW_REASON_LABEL[reason] || reason;
}

export function reviewReasonClientMessage(reason) {
  return REVIEW_REASON_CLIENT_MESSAGE[reason] || DEFAULT_REVIEW_CLIENT_MESSAGE;
}

export function isUnregisteredBank(reason) {
  return reason === "UNREGISTERED_BANK" || reason === "BANK_NOT_REGISTERED";
}
